
import { axios, BaseApiUrl ,BaseUrl} from '../axios_config';


export function GetWaitPickList(params) {
    return axios.post(`${BaseApiUrl}/WaitPick/GetWaitPickList`, params);
}

export function GetWaitPickStockList(params) {
    return axios.post(`${BaseApiUrl}/WaitPick/GetWaitPickStockList`, params);
}

export function ConfirmOffShelf(params) {
    return axios.post(`${BaseApiUrl}/WaitPick/ConfirmOffShelf`, params);
}



